import React, { useMemo } from 'react'
import AuctionDetails from './auctionDetails'
import {
  CardImage,
  AddressInfo,
  PropertyInfo,
  ListingUtils,
  Button,
} from '@adc/ui-core'
import configment from '@adc/configment'
import { type CurrentTargetAudience, Listing } from '@adc/sdk/types'
import classnames from 'classnames/bind'
import styles from './styles.scss'
import * as graph from '@adc/sdk'

const cx = classnames.bind(styles)

const { formatListingImgUrl } = ListingUtils.ListingFormatters

const LISTING_INFORMATION_PHOTO_WIDTH = 400

type InfoCardProps = {
  thumbnail?: React.ReactNode
  listing: Listing
  viewingFrom?: CurrentTargetAudience
  onEditListing: () => void
}
const ListingInfoCard = (props: InfoCardProps) => {
  const { listing, viewingFrom, onEditListing } = props

  const thumbnail = useMemo(() => {
    if (props.thumbnail) {
      return props.thumbnail
    }
    const listingPhotoUrl = formatListingImgUrl(
      listing?.primary_photo || configment.get('LISTING_DEFAULT_PHOTO_URL', ''),
      { width: LISTING_INFORMATION_PHOTO_WIDTH }
    )

    return (
      <CardImage
        listing={listing}
        listingPhotoUrl={listingPhotoUrl}
        defaultPhotoUrl={configment.get('LISTING_DEFAULT_PHOTO_URL', '')}
        className={cx('image')}
        viewingFrom={viewingFrom}
      />
    )
  }, [listing, props.thumbnail])
  const showEdit =
    viewingFrom &&
    [
      graph.enums.CurrentTargetAudience.Seller,
      graph.enums.CurrentTargetAudience.Staff,
    ].includes(viewingFrom)

  return (
    <div
      data-elm-id={`listing-info-card-${listing?.listing_id}`}
      className={cx('listing-info-card-section')}
    >
      {thumbnail}
      <AddressInfo
        address={listing?.formatted_address}
        className={cx('property-address')}
        elmId={`listing-info-card-address-info-${listing?.listing_id}`}
      />
      <PropertyInfo
        listing={listing}
        className={cx('property-info')}
        elmId={`listing-info-card-property-info-${listing?.listing_id}`}
      />
      <AuctionDetails listing={listing} viewingFrom={viewingFrom} />
      {showEdit ? (
        <div className={cx('button-container')}>
          <Button
            role='secondary'
            size='stretch'
            onClick={() => onEditListing?.()}
          >
            Edit Listing
          </Button>
        </div>
      ) : null}
    </div>
  )
}

export default ListingInfoCard
